import React, { Component } from 'react';

const Title = props => (
  <div className="container-account-title">
    <h2>
      {props.language
        ? props.language.account.accountUser.accountSettings.title
        : 'Configuración setting'}
      {props.state == null ? (
        ''
      ) : props.state ? (
        <i className="fas fa-check" />
      ) : (
        <i className="fas fa-times" />
      )}
    </h2>
  </div>
);

export default Title;



// WEBPACK FOOTER //
// ./source/client/components/account_setting/title.jsx